<template>
  <div class="" style="background-image: linear-gradient(60deg, #08182b 0%, #2c2b2b 100%);">
    <GalleryWrapper v-bind:slideshow="slideshow" />
    <GalleryControls v-on:next="nextSlide" v-on:prev="prevSlide" />
  </div>
</template>
<script>
const GalleryWrapper = () => import('./GalleryWrapper')
const GalleryControls = () => import('./GalleryControls')
import Slideshow from './slideshow.js'

export default {
  components: { GalleryWrapper, GalleryControls },
  data() {
    return {
      slideshow: null,
      slides: [
        {
          title: ['Pose'],
          images: [
            {
              src: 'images/slides/01-pose/pose-01.png',
              title: 'Pose XR - Pose 01',
            },
            {
              src: 'images/slides/01-pose/pose-02.png',
              title: 'Pose XR - Pose 02',
            },
            {
              src: 'images/slides/01-pose/pose-03.png',
              title: 'Pose XR - Pose 03',
            },
            {
              src: 'images/slides/01-pose/pose-04.png',
              title: 'Pose XR - Pose 04',
            },
          ],
        },
        {
          title: ['Direct'],
          images: [
            {
              src: 'images/slides/02-direct/direct-01.png',
              title: 'Pose XR - Direct 01',
            },
            {
              src: 'images/slides/02-direct/direct-02.png',
              title: 'Pose XR - Direct 02',
            },
            {
              src: 'images/slides/02-direct/direct-03.png',
              title: 'Pose XR - Direct 03',
            },
            {
              src: 'images/slides/02-direct/direct-04.png',
              title: 'Pose XR - Direct 04',
            },
          ],
        },
        {
          title: ['Shoot'],
          images: [
            {
              src: 'images/slides/03-shoot/shoot-01.png',
              title: 'Pose XR - Shoot 01',
            },
            {
              src: 'images/slides/03-shoot/shoot-02.png',
              title: 'Pose XR - Shoot 02',
            },
            {
              src: 'images/slides/03-shoot/shoot-03.png',
              title: 'Pose XR - Shoot 03',
            },
            {
              src: 'images/slides/03-shoot/shoot-01.png',
              title: 'Pose XR - Shoot 01',
            },
          ],
        },
      ],
    }
  },

  mounted() {
    this.setup()
    this.attachKeyboardListeners()
  },

  beforeDestroy() {
    this.detattachKeyboardListeners()
  },

  methods: {
    setup() {
      this.slideshow = new Slideshow(this.slides)
    },

    attachKeyboardListeners() {
      document.addEventListener('keyup', this.handleKeyboardEvents)
    },
    detattachKeyboardListeners() {
      document.removeEventListener('keyup', this.handleKeyboardEvents)
    },

    handleKeyboardEvents(event) {
      let activeElementType = document.activeElement.nodeName

      // We only listen for input if the activeElement is NOT an input, or text area
      if (
        !(activeElementType === 'INPUT' || activeElementType === 'TEXTAREA')
      ) {
        switch (event.code) {
          case 'ArrowLeft':
            this.prevSlide()
            event.preventDefault()
            event.stopPropagation()
            break
          case 'ArrowRight':
            this.nextSlide()
            event.preventDefault()
            event.stopPropagation()
            break
        }
      }
    },

    nextSlide() {
      this.slideshow.navigate('next')
    },
    prevSlide() {
      this.slideshow.navigate('prev')
    },
  },
}
</script>
